import React, { useEffect, useState } from "react";
import { GetBrands, addEditBrands } from "apis/MyDukanBrandApi";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Unstable_Grid2";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminateModal from "../../utils/Loading";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { setLoadingPanel } from "../../redux/features/loading";
import Autocomplete from "@mui/material/Autocomplete";
import { GetCategory } from "apis/MyDukanBrandApi";
import Pagination from "@mui/material/Pagination";
import SeriesModal from "components/SeriesModal";
import { ActionButton, SearchInput, Toolbar as UIToolbar, TableCard, FormCard } from "utils/ui";

export default function MyDukanBrands() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    position: 0,
    active: true,
    category: "",
    categoryName: "",
    categoryId: "",
    desc: "",
    image: "",
    displayOnSchemesBook: false,
    series: [],
  });
  const [seriesData, setSeriesData] = useState({
    name: "",
    desc: "",
    active: true,
    position: 1,
  });
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);

  const [seriesRows, setSeriesRows] = useState([
    { name: "", desc: "", active: true, position: 1 },
  ]);

  const [viewSeriesBrand, setViewSeriesBrand] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
    setFormData({
      id: "",
      name: "",
      position: 0,
      active: true,
      category: "",
      categoryName: "",
      categoryId: "",
      desc: "",
      image: "",
      displayOnSchemesBook: false,
      series: [],
    });
    setSeriesRows([{ name: "", desc: "", active: true, position: 1 }]);
    setIsEdit(false);
    GetCategory({ type: "all" }).then((res) => {
      setCategories(res.data.categories || []);
    });
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      id: "",
      name: "",
      position: 0,
      active: true,
      category: "",
      categoryName: "",
      categoryId: "",
      desc: "",
      image: "",
      displayOnSchemesBook: false,
      series: [],
    });
    setSeriesRows([{ name: "", desc: "", active: true, position: 1 }]);
    setIsEdit(false);
  };

  useEffect(() => {
    GetCategory({ subCategory: true }).then((res) => {
      setSubCategoryOptions(res.data.categories || []);
    });
  }, []);

  const getBrands = (categoryId = null, pageNum = 0) => {
    dispatch(setLoadingPanel(true));
    const params = { page: pageNum, size: 999};
    if (categoryId) params.categoryId = categoryId;
    GetBrands(params)
      .then((res) => {
        setBrands(res.data.brands || []);
        setTotalPages(res.data.totalPages || 1);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        toast(err?.response?.data?.message || "Error fetching brands", {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        if (err?.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  useEffect(() => {
    if (selectedCategory && selectedCategory.id) {
      getBrands(selectedCategory.id, page);
    } else {
      getBrands(null, page);
    }
  }, [selectedCategory, page]);

  useEffect(() => {
    const search = searchTerm.trim().toLowerCase();
    if (!search) {
      setFilteredBrands(brands);
    } else {
      setFilteredBrands(
        brands.filter((b) => {
          const name = typeof b.name === "string" ? b.name : "";
          return name.toLowerCase().includes(search);
        })
      );
    }
  }, [brands, searchTerm]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSeriesChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSeriesData({
      ...seriesData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleAddSeries = () => {
    setFormData({
      ...formData,
      series: [...formData.series, { ...seriesData }],
    });
    setSeriesData({ name: "", desc: "", active: true, position: 1 });
  };

  const handleAddSeriesRow = () => {
    setSeriesRows((prev) => [
      ...prev,
      { name: "", desc: "", active: true, position: 1 },
    ]);
  };

  const handleSeriesRowChange = (idx, e) => {
    const { name, value, type, checked } = e.target;
    setSeriesRows((prev) =>
      prev.map((row, i) =>
        i === idx
          ? { ...row, [name]: type === "checkbox" ? checked : value }
          : row
      )
    );
  };

  const handleRemoveSeriesRow = (idx) => {
    setSeriesRows((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleSave = () => {
    const { id, name, desc, position, active, categoryId } = formData;
    const payload = {
      id: isEdit ? id : "",
      name,
      desc,
      position: Number(position),
      active:
        active === true || active === "true" || active === 1 ? true : false,
      categoryId,
      series: seriesRows.map((s) => ({
        name: s.name,
        desc: s.desc,
        active:
          s.active === true || s.active === "true" || s.active === 1
            ? true
            : false,
        position: Number(s.position),
      })),
    };
    addEditBrands(payload)
      .then((res) => {
        toast(isEdit ? "Brand Updated" : "Brand Added", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
        getBrands();
      })
      .catch((err) => {
        toast(err?.response?.data?.message || "Error saving brand", {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      });
  };

  const handleEdit = (brand) => {
    setFormData({
      id: brand.id || "",
      name: brand.name || "",
      desc: brand.desc || "",
      position: brand.position || 0,
      active: brand.active,
      categoryId: brand.category || brand.categoryId || "",
      categoryName: brand.categoryName || "",
    });
    setSeriesRows([]);
    setIsEdit(true);
    setOpen(true);
  };

  const handleViewSeries = (brand) => {
    setViewSeriesBrand(brand);
  };

  const handleSaveSeries = (updatedSeries) => {
    const updatedBrand = {
      ...viewSeriesBrand,
      series: viewSeriesBrand.series.map((s) =>
        s.id === updatedSeries.id ? updatedSeries : s
      ),
    };
    setBrands(brands.map((b) => (b.id === updatedBrand.id ? updatedBrand : b)));
    setViewSeriesBrand(updatedBrand);
  };

  return (
    <>
      <CircularIndeterminateModal open={isLoading} />
      <FormCard>
        <UIToolbar>
          <SearchInput 
            placeholder="Search by brand name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <ActionButton icon="fas fa-plus" onClick={handleClickOpen}>Add Brand</ActionButton>
        </UIToolbar>
      </FormCard>
      <TableCard>
        <div className="flex justify-center p-4">
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={(_, value) => setPage(value - 1)}
            color="primary"
            size="medium"
          />
        </div>
        <div
          className="overflow-x-auto py-3 px-4 lg:p-8"
          key={filteredBrands.length}
        >
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <TableHeader heading="Name" />
                <TableHeader heading="Position" />
                <TableHeader heading="Category Name" />
                <TableHeader heading="Brand Series" style={{ maxWidth: 180 }} />
                <TableHeader heading="Action" />
              </tr>
            </thead>
            <tbody>
              {filteredBrands.map((brand, i) => (
                <tr
                  key={brand.id}
                  style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                >
                  <TableElement value={brand.name} />
                  <TableElement value={brand.position} />
                  <TableElement value={brand.categoryName} />
                  <TableElement
                    value={
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleViewSeries(brand)}
                      >
                        View Series
                      </Button>
                    }
                  />
                  <TableElement
                    value={
                      <span
                        className="cursor-pointer text-sky-500 hover:text-sky-950 font-bold"
                        onClick={() => {
                          handleEdit(brand);
                        }}
                      >
                        EDIT
                      </span>
                    }
                  />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableCard>
      {Boolean(viewSeriesBrand) && (
        <SeriesModal
          open={Boolean(viewSeriesBrand)}
          onClose={() => setViewSeriesBrand(null)}
          brand={viewSeriesBrand}
          onSaveSeries={handleSaveSeries}
        />
      )}
      <Dialog fullScreen open={open} onClose={handleClose}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              {isEdit ? `Edit Brand - ${formData.name}` : "Add Brand"}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
          <form>
            <div style={{ borderRadius: 8, padding: 0, marginBottom: 24 }}>
              <TextField
                required
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="Description"
                name="desc"
                value={formData.desc}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                type="number"
                label="Position"
                name="position"
                value={formData.position}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <FormControl
                fullWidth
                size="medium"
                sx={{ minWidth: 180, mb: 2 }}
              >
                <InputLabel shrink>Is Active</InputLabel>
                <Select
                  name="active"
                  value={formData.active}
                  onChange={handleChange}
                  label="Is Active"
                  displayEmpty
                >
                  <MenuItem value={true}>True</MenuItem>
                  <MenuItem value={false}>False</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <Autocomplete
                  options={categories}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    formData.categoryId && formData.categoryName
                      ? { id: formData.categoryId, name: formData.categoryName }
                      : null
                  }
                  onChange={(_, newValue) => {
                    setFormData({
                      ...formData,
                      categoryId: newValue ? newValue.id : "",
                      categoryName: newValue ? newValue.name : "",
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Category"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </FormControl>
              {!isEdit && (
                <div style={{ marginTop: 24 }}>
                  <div
                    style={{ fontWeight: 600, fontSize: 18, marginBottom: 12 }}
                  >
                    Series
                  </div>
                  {seriesRows.map((row, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 16,
                        marginBottom: 20,
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <TextField
                        label="Name"
                        name="name"
                        value={row.name}
                        onChange={(e) => handleSeriesRowChange(idx, e)}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        sx={{ flex: 1, minWidth: 180 }}
                      />
                      <TextField
                        label="Desc"
                        name="desc"
                        value={row.desc}
                        onChange={(e) => handleSeriesRowChange(idx, e)}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        sx={{ flex: 2, minWidth: 220 }}
                      />
                      <FormControl sx={{ minWidth: 110 }} size="small">
                        <InputLabel shrink>is active</InputLabel>
                        <Select
                          name="active"
                          value={row.active}
                          onChange={(e) => handleSeriesRowChange(idx, e)}
                          label="is active"
                          displayEmpty
                        >
                          <MenuItem value={true}>True</MenuItem>
                          <MenuItem value={false}>False</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        label="position"
                        name="position"
                        type="number"
                        value={row.position}
                        onChange={(e) => handleSeriesRowChange(idx, e)}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        sx={{ minWidth: 120 }}
                      />
                      <Button
                        variant="contained"
                        onClick={handleAddSeriesRow}
                        sx={{ minWidth: 40, px: 0, height: 40 }}
                      >
                        +
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave}>
            {isEdit ? "Save Changes" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
